"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoCompleteInputSchema = exports.default = void 0;
var AutoCompleteInput_1 = require("./AutoCompleteInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(AutoCompleteInput_1).default; } });
Object.defineProperty(exports, "autoCompleteInputSchema", { enumerable: true, get: function () { return AutoCompleteInput_1.autoCompleteInputSchema; } });
//# sourceMappingURL=index.js.map